import { addTrustedForm, setTCPALanguage, initAnura } from '../common';
import { execBigoS2SWebEvent, execNewsbreakPostback } from '../common/pixels';
import { dataTrigger } from '../creatives';
import { MP } from '../creatives/green';

const getAddressPanelPrizeCopy = (funnel_id) => {
  switch (funnel_id) {
    case 48:
      return "$25 Domino's eGift Card?";
    case 49:
      return '$25 BURGER KING&reg; eGift Card?';
    case 51:
      return '$25 Dunkin eGift Card?';
    default:
      return '$500 prize?';
  }
};

const modifyThemedElems = () => {
  const wrapper = document.getElementById('wrapper');
  wrapper
    .querySelectorAll('[panel-visibility="false"]')
    .forEach((e) => e.remove());

  wrapper.querySelectorAll('[trigger-action]').forEach((e) => {
    switch (e.getAttribute('trigger-action')) {
      case 'hide':
        e.remove();
        break;
      case 'show':
        e.style.display = 'block';
        let offset = e.offsetHeight;
        document.querySelector(
          '#wrapper .container',
        ).style.height = `calc(100% - ${offset}px)`;
        break;
    }
  });
};

const schema = {
  email_address: {
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);

      if (document.getElementById('changing_text')) {
        document.getElementById('changing_text').remove();
      }

      if (window.sooper_panel.props.advance_theming) {
        modifyThemedElems();
      }

      if (
        !document.body.hasAttribute('is-detour') &&
        window.sooper_panel.props.creative
      ) {
        window.sooper_panel.props.creative === 'green'
          ? MP()
          : dataTrigger('email-submit');
      }

      if (document.getElementById('countdown')) {
        document.getElementById('countdown').remove();
      }

      if (window.sooper_panel.wrapper.querySelectorAll('.blurb').length) {
        window.sooper_panel.wrapper
          .querySelectorAll('.blurb')
          .forEach(function (e) {
            e.remove();
          });
      }

      document.getElementById('labels').style.display = 'block';

      if (document.querySelector('.congrats-large')) {
        document.querySelector('.congrats-large').classList.add('lrg');
      }

      window.sooper_panel.controller.continueBtn.innerHTML = 'NEXT';
      window.sooper_panel.controller.continueBtn.classList.remove('minSubBtn');

      if (
        window.sooper_panel.props.funnel_id &&
        window.sooper_panel.props.funnel_id === 33 &&
        document.querySelector('div.landing_title')
      ) {
        document.querySelector('div.landing_title').remove();
      }

      if (
        window.sooper_panel.props.funnel_id &&
        parseInt(window.sooper_panel.props.funnel_id) === 49 &&
        document.querySelector('h1.win-a-chance')
      ) {
        document.querySelector('h1.win-a-chance').remove();
      }

      if (window.sooper_panel.wrapper.hasAttribute('data-testfb')) {
        var script = document.createElement('script');
        script.innerHTML = `!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '261875876348215');
        fbq('track', 'PageView');`;
        document.head.appendChild(script);

        var noscript = document.createElement('noscript'),
          img = document.createElement('img');

        img.setAttribute(
          'src',
          'https://www.facebook.com/tr?id=261875876348215&ev=PageView&noscript=1',
        );
        img.setAttribute('height', 1);
        img.setAttribute('width', 1);
        noscript.appendChild(img);
        document.head.appendChild(noscript);
      }

      if (
        typeof _tfa === 'object' &&
        window.sooper_panel.props.source
          .toLowerCase()
          .indexOf('taboolasweeps603') !== -1
      ) {
        _tfa.push({ notify: 'event', name: 'lead', id: 1666862 });
      }

      console.log(window.sooper_panel.props.profile.VisitIndex);

      if (
        typeof nbpix === 'function' &&
        window.sooper_panel.query_params?.s4 &&
        window.sooper_panel.props.source
          .toLowerCase()
          .indexOf('newsbreaksweeps2327') !== -1
      ) {
        console.log('NEWSBREAK');
        execNewsbreakPostback({
          click_id: window.sooper_panel.query_params?.s4,
          visit_id: window.sooper_panel.props.visit_id,
          email_address: value,
          event_type: 'submit_form',
        });
      }

      if (
        // window.sooper_panel.query_params?.bbg &&
        typeof bge === 'function' &&
        window.sooper_panel.props.source
          .toLowerCase()
          .indexOf('bigosweeps2267') !== -1 &&
        window.sooper_panel.props.profile.VisitIndex < 10
      ) {
        bge('event', 'ec_register', { configId: '904524507069455360' });

        if (typeof window.sooper_panel.query_params.bbg === 'string') {
          console.log('BIGO');
          execBigoS2SWebEvent({
            // pixel_id: 904813345937232384,
            pixel_id: '904524507069455360',
            visit_id: window.sooper_panel.props.visit_id,
            email_address: value,
            bbg: window.sooper_panel.query_params.bbg,
            // cookie_id: window.sooper_panel.props.browserStorage?._bge_ci,
            event: {
              event_id: 'ec_register',
            },
          });
        }
      }
      // console.log(window.sooper_panel.props.visit_id);
      initAnura(
        window.sooper_panel.props.visit_id,
        window.sooper_panel.props.anuranum,
        window.sooper_panel.props.anuraper,
      );
    },
  },
  first_name: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? "We need our next winner's name"
        : "We need our next winner's FIRST name.",
    beforeSubmit: () => addTrustedForm(),
    afterSubmit: (value) => {
      // addTrustedForm()
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  last_name: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Confirm your last name.'
        : 'Confirm your LAST name.',
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  address_1: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Great! You qualify! Now if you win, where do we mail your $500 prize?'
        : 'If you win, where do we mail your ' +
          getAddressPanelPrizeCopy(
            parseInt(
              document
                .querySelector('[data-funnel-id]')
                .getAttribute('data-funnel-id'),
            ),
          ),
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);

      if (typeof trustedForm !== 'object') {
        return;
      }

      if (window.sooper_panel?.certificate_url !== 'undefined') {
        return;
      }

      window.sooper_panel.props.certificate_url = `https://cert.trustedform.com/${trustedForm.id}`;
      window.sooper_panel.certificate_url = `https://cert.trustedform.com/${trustedForm.id}`;
    },
  },
  city: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'In what city do you reside?'
        : 'In what city do you reside?',
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  state: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Select your state from the dropdown.'
        : 'Select your state from the dropdown.',
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  zip_code: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Confirm we ship our $10,00 prize to your ZIP CODE.'
        : 'What is your zip code?',
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  birth_month: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'In what month where you born?'
        : 'Are you old enough to enter? When were you born?',
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  birth_day: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'On what day were you born?'
        : 'On what day were you born?',
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  birth_year: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Are you old enough to enter? When were you born?'
        : 'What year were you born?',
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  gender: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'What is your gender?'
        : 'What is your gender?',
    afterSubmit: (value) => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);

      window.sooper_panel.certificate_url = document
        .getElementById('panel-wrapper')
        .getAttribute('data-certificate-url');

      window.sooper_panel.controller.continueBtn.innerHTML =
        "YOU'RE ALMOST THERE!";
      window.sooper_panel.controller.continueBtn.parentNode.insertBefore(
        setTCPALanguage(),
        document.getElementById('continue'),
      );
      window.sooper_panel.controller.continueBtn.classList.add('submit');

      if (typeof trustedForm !== 'object') {
        return;
      }

      // if (window.sooper_panel?.certificate_url !== 'undefined') {
      //   return;
      // }

      window.sooper_panel.props.certificate_url = `https://cert.trustedform.com/${trustedForm.id}`;
      window.sooper_panel.certificate_url = `https://cert.trustedform.com/${trustedForm.id}`;
    },
  },
  phone_number: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? "We contact our winner by phone. What's the best number to reach you?"
        : "If you win, what's the best number to reach you?",
  },
};

export default class Creative {
  constructor() {
    Object.assign(this, schema);
  }
}
